import { Cluster } from '@cast/types';

import { FeatureSelection } from './types';

import { isAKSCluster } from '@cast/shared-cluster-context-data-access';

export const isPremiumFeatureSelected = (
  featureSelection: FeatureSelection
): boolean =>
  featureSelection.autoscaler || featureSelection.workloadAutoscaler;

type GenerateRedirectPathArgs = {
  enabledFeatures: FeatureSelection;
  cluster: Cluster;
  isInSecurityPage: boolean;
  isSecuritySunsetEnabled?: boolean;
};

export const generateRedirectPath = ({
  enabledFeatures,
  cluster,
  isInSecurityPage,
  isSecuritySunsetEnabled = false,
}: GenerateRedirectPathArgs): string | undefined => {
  const autoscalerEnabled = enabledFeatures.autoscaler;
  const workloadAutoscalerEnabled = enabledFeatures.workloadAutoscaler;
  const securityEnabled = !isSecuritySunsetEnabled && enabledFeatures.security;
  const conflictingFeaturesEnabled =
    [autoscalerEnabled, workloadAutoscalerEnabled].filter(Boolean).length > 1;

  if (
    isInSecurityPage ||
    (securityEnabled && !autoscalerEnabled && !workloadAutoscalerEnabled)
  ) {
    return '/organization/security/dashboard';
  }

  if (conflictingFeaturesEnabled) {
    return `/dashboard`;
  }

  if (isAKSCluster(cluster)) {
    // no redirects to autoscaler for AKS due to long setup
    return;
  }

  if (workloadAutoscalerEnabled) {
    return `/external-clusters/${cluster.id}/workload-optimization/workloads`;
  }

  if (autoscalerEnabled) {
    return `/external-clusters/${cluster.id}/autoscaler`;
  }
  return undefined;
};
